import { NotificationSnackBar } from "@/controls/snackbars/notification-snackbar";
import { ErrorModal, HelmetDexteel, MesfModal } from "@dexteel/mesf-core";
import { capitalize } from "lodash-es";
import { useRef, useState } from "react";
import {
	TEMPLATE_MODAL_TITLES,
	TemplateModalTarget,
} from "../utils/templateModal";
import { TemplateDraftForm } from "./TemplateDraftForm";

type Props = {
	target: TemplateModalTarget | null;
	onHide: () => void;
};

export const UpsertDeleteTemplateModal = ({ target, onHide }: Props) => {
	const [notificationMessage, setNotificationMessage] = useState("");
	const [error, setError] = useState("");

	const lastTarget = useRef<TemplateModalTarget | null>(null);
	if (target !== null) lastTarget.current = target;

	const shown = target ?? lastTarget.current;
	const title = shown === null ? "" : TEMPLATE_MODAL_TITLES[shown.mode];

	return (
		<>
			{target !== null && (
				<HelmetDexteel title={`${capitalize(title)} - Inspection Templates`} />
			)}
			<MesfModal
				id="modal-inspection-template"
				title={title}
				open={target !== null}
				handleClose={onHide}
				maxWidth="md"
			>
				{shown !== null && (
					<TemplateDraftForm
						key={shown.openedAt}
						target={shown}
						onHide={onHide}
						onSaved={(message) => {
							setNotificationMessage(message);
							onHide();
						}}
						onError={setError}
					/>
				)}
			</MesfModal>
			<NotificationSnackBar
				message={notificationMessage}
				onHide={() => setNotificationMessage("")}
			/>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
